import { render } from "./MasterDataView.vue?vue&type=template&id=325a9f2a&scoped=true&ts=true"
import script from "./MasterDataView.vue?vue&type=script&lang=ts"
export * from "./MasterDataView.vue?vue&type=script&lang=ts"

import "./MasterDataView.vue?vue&type=style&index=0&id=325a9f2a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325a9f2a"]])

export default __exports__